var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"p-4",class:{
    'bg-red-500': _vm.player === 1,
    'bg-blue-500': _vm.player === 2
  }},[_c('p',{staticClass:"pb-4 text-center text-white font-bold"},[_vm._v("行き先を選ぶ")]),_c('div',{staticClass:"container mx-auto grid grid-cols-2 sm:grid-cols-4 gap-4"},_vm._l((_vm.sceneList()),function(scene){return _c('button',{key:scene,staticClass:"block w-full text-white font-bold p-2 rounded",class:{
        'bg-red-700': _vm.player === 1,
        'hover:bg-red-900': _vm.player === 1,
        'bg-blue-700': _vm.player === 2,
        'hover:bg-blue-900': _vm.player === 2
      },on:{"click":function($event){return _vm.select(scene)}}},[_vm._v(" "+_vm._s(_vm.sceneName(scene))+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }